<template>
  <div class="content">
    <div class="body">
      <div class="vs-container" v-if="leftUser && rightUser">
        <div class="vs-header">
          <div class="vs-avatar-side" :style="{ background: getHeaderBackground(1) }">
            <img v-if="leftWinsOverall" class="huangguan huangguan1" src="../../assets/huangguan.png">
            <img :src="leftUser.img" class="touxiang" :onerror="`this.onerror=null;this.src='${touxiang}';`">
            <div class="nickname">{{ leftUser.nickname }}</div>
          </div>
          <div class="vs-title">VS</div>
          <div class="vs-avatar-side" :style="{ background: getHeaderBackground(2) }">
            <img v-if="rightWinsOverall" class="huangguan huangguan2" src="../../assets/huangguan.png">
            <img :src="rightUser.img" class="touxiang" :onerror="`this.onerror=null;this.src='${touxiang}';`">
            <div class="nickname">{{ rightUser.nickname }}</div>
          </div>
        </div>
        <div
          class="list"
          v-for="(item, i) in vsItems"
          :key="item.key"
          :style="{ zIndex: i }"
        >
            <div class="nickname">
                <span>{{ item.label }}</span>
            </div>
          <div class="item-inner logo">
            <img :src="leftUser.img" class="touxiang" :onerror="`this.onerror=null;this.src='${touxiang}';`">
          </div>
          <div class="item">
            <div class="item-inner vs-bar-wrapper">
              <div class="vs-bar">
                <div
                  class="vs-bar-inner left"
                  :style="{
                    width: calcWidth(item, 1),
                    background: getItemBackground(item, 1)
                  }"
                >
                  <span>{{ Math.round(leftVs[item.key] || 0) }}</span>
                  <img class="fire" src="../../assets/fire.png">
                </div>
                <div
                  class="vs-bar-inner right"
                  :style="{
                    width: calcWidth(item, 2),
                    background: getItemBackground(item, 2)
                  }"
                >
                  <span>{{ Math.round(rightVs[item.key] || 0) }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item-inner logo">
            <img :src="rightUser.img" class="touxiang" :onerror="`this.onerror=null;this.src='${touxiang}';`">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userList from './data-0622.js'
import axios from '../axios-instance'

export default {
  name: 'pageTpPaimingJs',
  data () {
    return {
      vsData: { 4: { zf: 0, byb: 0, zlrs: 0 }, 29: { zf: 0, byb: 0, zlrs: 0 } },
      vsTarget: { 4: { zf: 0, byb: 0, zlrs: 0 }, 29: { zf: 0, byb: 0, zlrs: 0 } },
      vsInterval: null,
      vsAnimating: false,
      touxiang: require('../../assets/touxiang.png'),
      interval: undefined
    }
  },
  computed: {
    leftUser () {
      return userList.find(e => e.id === 4)
    },
    rightUser () {
      return userList.find(e => e.id === 29)
    },
    leftVs () {
      return this.vsData[4] || { zf: 0, byb: 0, zlrs: 0 }
    },
    rightVs () {
      return this.vsData[29] || { zf: 0, byb: 0, zlrs: 0 }
    },
    vsItems () {
      return [
        { key: 'zf', label: '总分' },
        { key: 'byb', label: '榜一百' },
        { key: 'zlrs', label: '助力人数' }
      ]
    },
    leftWinCount () {
      let count = 0
      this.vsItems.forEach(item => {
        if ((this.leftVs[item.key] || 0) > (this.rightVs[item.key] || 0)) count++
      })
      return count
    },
    rightWinCount () {
      let count = 0
      this.vsItems.forEach(item => {
        if ((this.rightVs[item.key] || 0) > (this.leftVs[item.key] || 0)) count++
      })
      return count
    },
    leftWinsOverall () {
      return this.leftWinCount > this.rightWinCount
    },
    rightWinsOverall () {
      return this.rightWinCount > this.leftWinCount
    },
    isDraw () {
      return this.leftWinCount === this.rightWinCount
    }
  },
  mounted () {
    this.interval = setInterval(() => {
      this.getAllData()
    }, 20000)
    this.getAllData(true)
  },
  beforeDestroy () {
    clearInterval(this.interval)
    clearInterval(this.vsInterval)
  },
  methods: {
    getAllData (isFirst) {
      const lastRequestTime = window.localStorage.getItem('requestTime0627js')
      if (lastRequestTime && Date.now() - lastRequestTime < 9000) {
        this.loadedVs(JSON.parse(window.localStorage.getItem('cacheData0627js') || '{}'), isFirst)
        return
      }
      this.getVsData().then((vsRes) => {
        if (vsRes && vsRes.data.code === 0) {
          window.localStorage.setItem('requestTime0627js', Date.now())
          window.localStorage.setItem('cacheData0627js', JSON.stringify(vsRes.data.data))
          this.loadedVs(vsRes.data.data, isFirst)
        } else {
          this.loadedVs(JSON.parse(window.localStorage.getItem('cacheData0627js') || '{}'), isFirst)
        }
      }).catch((e) => {
        console.error(e)
        this.loadedVs(JSON.parse(window.localStorage.getItem('cacheData0627js') || '{}'), isFirst)
      })
    },
    getVsData () {
      return axios({
        url: `https://yudao-api.yunlvltd.com/app-api/vote/kv/get/0627jsdata`,
        method: 'get',
        headers: {
          'tenant-id': 1
        }
      }).then(res => {
        return { data: { code: 0, data: this.parseResponseData(res) } }
      })
    },
    parseResponseData (res) {
      if (res.data && res.data.code === 0 && res.data.data) {
        if (typeof res.data.data === 'string') {
          try {
            return JSON.parse(res.data.data)
          } catch (e) {
            console.error('响应数据解析失败：', e)
            return {}
          }
        }
        return res.data.data
      }
      return {}
    },
    loadedVs (data, isFirst) {
      const parsed = data || {}
      const left = parsed[4] || {}
      const right = parsed[29] || {}
      this.vsTarget = {
        4: { zf: left.zf || 0, byb: left.byb || 0, zlrs: left.zlrs || 0 },
        29: { zf: right.zf || 0, byb: right.byb || 0, zlrs: right.zlrs || 0 }
      }
      if (isFirst) {
        this.vsData = {
          4: { zf: 0, byb: 0, zlrs: 0 },
          29: { zf: 0, byb: 0, zlrs: 0 }
        }
      }
      this.animateVsData()
    },
    animateVsData () {
      if (this.vsInterval) {
        clearInterval(this.vsInterval)
        this.vsInterval = null
      }
      const steps = 40
      const step = { 4: {}, 29: {} }
      this.vsItems.forEach(item => {
        step[4][item.key] = ((this.vsTarget[4][item.key] || 0) - (this.vsData[4][item.key] || 0)) / steps
        step[29][item.key] = ((this.vsTarget[29][item.key] || 0) - (this.vsData[29][item.key] || 0)) / steps
      })
      let i = 0
      this.vsAnimating = true
      this.vsInterval = setInterval(() => {
        i++
        const next = {
          4: { ...this.vsData[4] },
          29: { ...this.vsData[29] }
        }
        this.vsItems.forEach(item => {
          next[4][item.key] += step[4][item.key]
          next[29][item.key] += step[29][item.key]
        })
        this.vsData = next
        if (i >= steps) {
          clearInterval(this.vsInterval)
          this.vsInterval = null
          this.vsAnimating = false
        }
      }, 50)
    },
    calcWidth (item, flag) {
      const t1 = this.leftVs[item.key] || 0
      const t2 = this.rightVs[item.key] || 0
      const total = t1 + t2
      if (total === 0) return '50%'

      const containerWidth = 1332
      const minWidth = 200
      const minPct = (minWidth / containerWidth) * 100

      let p1 = (t1 / total) * 100
      let p2 = (t2 / total) * 100

      if (p1 < minPct && p2 >= 100 - minPct) {
        p1 = minPct
        p2 = 100 - minPct
      } else if (p2 < minPct && p1 >= 100 - minPct) {
        p2 = minPct
        p1 = 100 - minPct
      }

      return (flag === 1 ? p1 : p2) + '%'
    },
    getBackground (flag, isWinner) {
      const coloredLeft = 'linear-gradient(to right, rgb(61 23 102), rgb(90 24 154), rgb(123 44 191))'
      const coloredRight = 'linear-gradient(to right, rgb(123 44 191), rgb(90 24 154), rgb(61 23 102))'
      const grayLeft = 'linear-gradient(to right, rgb(122 122 133), rgb(98 98 110), rgb(78 78 90))'
      const grayRight = 'linear-gradient(to right, rgb(122 122 133), rgb(98 98 110), rgb(78 78 90))'
      if (flag === 1) {
        return isWinner ? coloredLeft : grayLeft
      }
      return isWinner ? coloredRight : grayRight
    },
    getHeaderBackground (flag) {
      const isWinner = flag === 1 ? this.leftWinsOverall : this.rightWinsOverall
      const isLoser = flag === 1 ? this.rightWinsOverall : this.leftWinsOverall
      if (this.isDraw || isWinner) {
        return this.getBackground(flag, true)
      }
      return this.getBackground(flag, false)
    },
    getItemBackground (item, flag) {
      const t1 = this.leftVs[item.key] || 0
      const t2 = this.rightVs[item.key] || 0
      const isWinner = flag === 1 ? t1 >= t2 : t2 >= t1
      return this.getBackground(flag, isWinner)
    }
  }
}
</script>

<style scoped>
.content {
  position: relative;
  width: 3000px;
  height: 1200px;
  font-size: 22px;
  background: green;
}

.body {
  position: relative;
  width: 54%;
  height: 97%;
  margin: 0 auto;
  padding-top: 1%;
  box-sizing: border-box;
  overflow: hidden;
}

.vs-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.vs-header {
  width: 100%;
  height:25%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2%;
  box-sizing: border-box;
}

.vs-avatar-side {
  width: 35%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  border: 4px solid rgba(255, 255, 255, 0.6);
  position: relative;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

.vs-avatar-side .touxiang {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  border: 4px solid #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.vs-avatar-side .nickname {
  margin-top: 18px;
  font-size: 40px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
}

.vs-title {
  font-size: 90px;
  font-weight: bold;
  color: #e6d49a;
  text-shadow: 0 3px 10px rgba(0, 0, 0, 0.6);
}
.huangguan1 {
  position: absolute;
    top: -23px;
    left: 41%;
  transform: translateX(-50%);
  width: 90px;
  height: auto;
  z-index: 10;
}
.huangguan2 {
  position: absolute;
    top: -23px;
    left: 41%;
  transform: translateX(-50%);
  width: 90px;
  height: auto;
  z-index: 10;
}

.list {
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
  margin: 1% 0;
  position: relative;
}

.list .logo {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 24px;
  flex-shrink: 0;
  position: relative;
}

.list .touxiang {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.35);
}

.list .item {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.list .nickname {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  font-size: 44px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  margin-bottom: 14px;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
}

.list .vs-bar-wrapper {
  position: relative;
  width: 100%;
  height: 70px;
}

.list .vs-bar {
  width: 100%;
  height: 100%;
  display: flex;
  border: 3px solid #fff;
  border-radius: 14px;
  background: transparent;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.vs-bar-inner {
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  font-size: 30px;
  color: #fff;
  padding: 0 12px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
  border-radius: 9px;
}

.vs-bar-inner.left {
  justify-content: flex-start;
}

.vs-bar-inner.right {
  justify-content: flex-end;
}

.fire {
  position: absolute;
  right: -50px;
  top: 50%;
  transform: translateY(-50%);
  height: 240%;
  width: auto;
  z-index: 5;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/page260622/page-tp-paiming-js.vue